import { Star } from 'lucide-react';

const ReviewBanner = () => {
  return (
    <div className="review-banner" data-testid="review-banner">
      <a 
        href="https://g.page/r/CZIipnthC_CTEBI/review" 
        target="_blank" 
        rel="noopener noreferrer" 
        className="review-banner-link"
      >
        <Star size={18} className="review-banner-star" />
        <span>Please leave a paw-sitive review</span>
        <Star size={18} className="review-banner-star" />
      </a>
    </div>
  );
};

export default ReviewBanner;
